import { render, staticRenderFns } from "./TextCell.vue?vue&type=template&id=53d86066&scoped=true"
import script from "./TextCell.vue?vue&type=script&lang=js"
export * from "./TextCell.vue?vue&type=script&lang=js"
import style0 from "./TextCell.vue?vue&type=style&index=0&id=53d86066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d86066",
  null
  
)

export default component.exports